@if (memoryUsage$ | async; as memoryUsage) {
  <div class="memory-indicator">
    <div id="label">MEMORY</div>
    <div id="percentage">{{ memoryUsage }}%</div>
  </div>
}
